import React, { useEffect, useState } from 'react'
import './QueryReport.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Paper, Toolbar, Tooltip, Typography } from '@mui/material';
import styled from '@emotion/styled';
import SearchModal from './components/SearchModal/SearchModal';
import {ReactComponent as Column} from "../../../assets/images/CommonComponent/columns.svg"
import SelectColumnModal from './components/SelectColumnModal/SelectColumnModal';
import { getAnandaKeysCategoryList, getQueryReport, downloadQueryReport } from '../../../redux/actions/AnalyticalReportAction/QueryReportAction';
import { downloadExcel, parseJSON } from '../../../utils/Helper';
import { useSearchParams } from 'react-router-dom';
import QueryReportTable from './components/QueryReportTable';
import {ReactComponent as SearchIcon} from '../../../assets/images/search.svg'
import Button from '../../../components/Button/Button';
import DownloadButton from '../../../components/Button/DownloadButton';

const defaultColumns = [
    {
        "label": "First Name",
        "data_type": "string",
        "table": "users",
        "tableLabel": "Guest",
        "json_key": null,
        "selected_json_key": null,
        "selected_json_key_label": "First Name",
        "column_name": "first_name",
        "for_unique_key_alias": null,
        "row_id": null,
        "extra_key": null,
        "can_delete": false
    },
    {
        "label": "Last Name",
        "data_type": "string",
        "table": "users",
        "tableLabel": "Guest",
        "json_key": null,
        "selected_json_key": null,
        "selected_json_key_label": "Last Name",
        "column_name": "last_name",
        "for_unique_key_alias": null,
        "row_id": null,
        "extra_key": null,
        "can_delete": false
    },
    {
        "label": "Program Name",
        "data_type": "dropdown",
        "table": "ananda_programs",
        "tableLabel": "Program Details",
        "table_name_alias": null,
        "json_key": null,
        "selected_json_key_label": "Program Name",
        "selected_json_key": null,
        "column_name": "title",
        "for_unique_key_alias": "ananda_program_name",
        "row_id": null,
        "extra_key": null,
        "can_delete": false
    }
]

  
const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const getColumns = ()=>{
    let d = parseJSON(localStorage.getItem('query')) || {};
    let dynamicCol = d?.columns?.map(item=>({
        id: item.column_name, label: item.label, sortingKey: item.column_name, sort: false, width: '200px', dataType: item.data_type, ...item
    })) || []
    const columns = [
        ...dynamicCol
    ];

    return columns
}

function QueryReport(props) {
    const [openModal, setOpenModal] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const [openSelectColumnModal, setOpenSelectColumnModal] = useState(false)
    const [filter, setFilter] = useState({
        searchText: searchParams.get("search") || '',
      })

    const { activeTab } = props;
    const dispatch = useDispatch()
    const data = useSelector(state => state?.queryReportReducer);
    const prevSearchParamsRef = React.useRef(searchParams);
    const prevParams = prevSearchParamsRef.current;

    const getTableData = ()=>{
        let d = parseJSON(localStorage.getItem('query')) || {}
        if(!d.columns){
            d.columns = defaultColumns
            d.condition= 'and'
            localStorage.setItem('query', JSON.stringify(d))
        }

        const prevOrderBy = prevParams.get('orderBy') || '';
        const newOrderBy = searchParams.get('orderBy') || '';
        const prevOrderByType = prevParams.get('orderByType') || '';
        const newOrderByType = searchParams.get('orderByType') || '';
    
        const hasSortChanged = prevOrderBy !== newOrderBy || prevOrderByType !== newOrderByType;
        dispatch(getQueryReport({
            ...d,
            page: searchParams.get("page") ? parseInt(searchParams.get("page"))+1 : 1,
            pageLimit: searchParams.get("pageLimit") || 50,
            orderBy: searchParams.get("orderBy") || '',
            orderByType: searchParams.get("orderByType") || '',
            ...filter,
            hideLoder: hasSortChanged
        }))
    }

    const downloadTableData = ()=>{
        let d = parseJSON(localStorage.getItem('query')) || {}
        if(!d.columns){
            d.columns = defaultColumns
            d.condition= 'and'
            localStorage.setItem('query', JSON.stringify(d))
        }
        const onSuccessCallback = (data)=>{
            downloadExcel({data, fileName: 'Ananda Analytical Report.xlsx'})
          }

        dispatch(downloadQueryReport({
            ...d,
            page: searchParams.get("page") ? parseInt(searchParams.get("page"))+1 : 1,
            pageLimit: searchParams.get("pageLimit") || 50,
            orderBy: searchParams.get("orderBy") || '',
            orderByType: searchParams.get("orderByType") || '',
            ...filter,
            onSuccessCallback
        }))
    }

    useEffect(()=>{
        if(activeTab==='queryReport'){
            getTableData()
        }
        prevSearchParamsRef.current = searchParams;
    }, [activeTab, searchParams])

    React.useEffect(()=>{ 
        if(!data?.keysCategoryList?.length)
            dispatch(getAnandaKeysCategoryList())
    }, [])

    return (
        <div className="queryReport" >
            <Box sx={{ width: '100%', minHeight: '300px', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}>
                <Paper sx={{ width: '100%', borderRadius: 0, borderTopLeftRadius: '8px', borderTopRightRadius: '8px', boxShadow: 'none'}}>
                    <Toolbar sx={{
                        p: '10px !important',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                    >
                        <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-3'>
                            <MainHeading
                                sx={{ flex: '1 1 100%', }}
                                variant="h6"
                                id="tableTitle"
                                component="div"
                            >
                                Report
                            </MainHeading>
                        </div>
                        <div className='d-flex align-items-center'>
                            <DownloadButton
                                loading={data.downloadLoader}
                                disabled={data.downloadLoader}
                                text={'Download Excel'}
                                onClick={downloadTableData}
                            />
                            <Button 
                                icon={<SearchIcon fontSize={'19px'} />}
                                text={'Advanced Search'}
                                onClick={()=>setOpenModal(true)}
                            />
                            <Tooltip title={'Select Columns'}>
                                <Column className='cursor-pointer' fontSize={27} onClick={()=> setOpenSelectColumnModal(true)} />
                            </Tooltip>
                        </div>
                    </Toolbar>
                    </Paper>
                    <div className='dashboard' style={{ height: 'calc(100vh - 185px)'}}>
                        <QueryReportTable
                            checkbox={false}
                            columns={getColumns()}
                            loading={data.loading}
                            data ={data.queryReport?.data || []}
                            pagination={data.queryReport?.list?.length}
                            totalCount={data.queryReport?.total}
                            totalPages={data.queryReport?.total_pages}
                            start={(data.queryReport?.current_page_no - 1) * (data.queryReport?.end-data.queryReport?.start) + 1}
                            end={(data.queryReport?.current_page_no - 1) * (data.queryReport?.end-data.queryReport?.start) + data.queryReport?.list?.length}
                            currentPage={data.queryReport?.current_page_no-1}
                            rowsPerPage={searchParams.get("pageLimit") || 50}
                            filter={filter}
                            getTableData={getTableData}
                        />
                    </div>
            </Box>
            {
                openModal &&
                <SearchModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                />
            }
            {
                openSelectColumnModal &&
                <SelectColumnModal
                    openModal={openSelectColumnModal}
                    setOpenModal={setOpenSelectColumnModal}
                    defaultColumns={defaultColumns}
                />
            }
        </div>
    )
}

export default QueryReport